import { render, staticRenderFns } from "./PointLabelSmall.vue?vue&type=template&id=669b6a6e&scoped=true&"
import script from "./PointLabelSmall.vue?vue&type=script&lang=js&"
export * from "./PointLabelSmall.vue?vue&type=script&lang=js&"
import style0 from "./PointLabelSmall.vue?vue&type=style&index=0&id=669b6a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b6a6e",
  null
  
)

export default component.exports